const Sidebar = ($sidebar) => {
  const parentElements = $sidebar.querySelectorAll(".sidebar__parent");

  parentElements.forEach((el) => {
    const icon = el.querySelector(".sidebar__icon");
    if (!icon) return;

    icon.addEventListener("click", () => {
      el.classList.toggle("close");
    });
  });

  const handleResize = () => {
    if (window.innerWidth < 1300) {
      parentElements.forEach((parEl) => parEl.classList.add("close"));
    } else {
      parentElements.forEach((parEl) => parEl.classList.remove("close"));
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);
};

document.addEventListener("DOMContentLoaded", () => {
  const sidebarElement = document.querySelector(".sidebar__wrapper");
  if (sidebarElement) {
    Sidebar(sidebarElement);
  }
});

// const Sidebar = ($sidebar) => {
//   const parentElements = document.querySelectorAll(".collection-item__parent .icon");
//   const childElements = document.querySelectorAll(".collection-item__list");

//   const handleResize = () => {
//     if (window.innerWidth < 1300) {
//       childElements.forEach((childEl) => childEl.classList.add("close-filter"));
//       parentElements.forEach((parEl) => (parEl.innerHTML = "&plus;"));
//     } else {
//       childElements.forEach((childEl) => childEl.classList.remove("close-filter"));
//       parentElements.forEach((parEl) => (parEl.innerHTML = "&mdash;"));
//     }
//   };

//   handleResize();
//   window.addEventListener("resize", handleResize);

//   parentElements.forEach((parEl) => {
//     parEl.addEventListener("click", function () {
//       const parentCat = parEl.closest(".collection-item__parent").getAttribute("data-cat");
//       const childElement = document.querySelector(`.collection-item__list[data-cat="${parentCat}"]`);

//       if (childElement) {
//         childElement.classList.toggle("close-filter");
//         if (childElement.classList.contains("close-filter")) {
//           parEl.innerHTML = "&plus;";
//         } else {
//           parEl.innerHTML = "&mdash;";
//         }
//       }
//     });
//   });
// };

// const init = function () {
//   const sidebarElement = document.querySelector(".sidebar__wrapper");
//   if (sidebarElement) {
//     Sidebar(sidebarElement);
//   }
// };

// document.addEventListener("DOMContentLoaded", init);
